// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    height: 100%;
}

.home {
    background-color: #001a45;
    margin-top: -50px;
    padding-top: 50px;
    min-height: 100%;
}

.home .container {
    display: flex;
    height: auto;
    width: 100%;
    max-width: 1920px;
    padding: 0;
    margin: 0 auto;
    justify-content: center;
}
.potd {
    display: flex;
}

.potd-container {
    margin-top: 40px;
    border-right: 2px ;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    height: 800px;
}

.potd-header {
    color: #15F4EE;
    text-shadow: 0 0 0.125em hsl(0 0% 100% / 0.5), 0 0 0.45em #15F4EE;
    margin-top: 30px;
    margin-right: 60px;
    font-size: 24px;
    writing-mode: vertical-lr;
    text-orientation: upright;
}

.potd-container .pokemon-card {
    position: relative;
    min-width: 300px;
    max-width: 60%;
    border: 10px solid rgb(253,226,101);
    border-radius: 20px;
    background: rgb(210,213,205, 0.8);
    background: linear-gradient(90deg, rgba(210,213,205,0.8) 0%, rgba(255,255,255,0.8) 50%, rgba(218,221,214,0.8) 100%);
    box-shadow: 0 0 1px 1px #A89A75 inset;
    box-shadow: 0 0 10px 3px #15F4EE;
    animation-name: bounce;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: ease;
}

.potd-container .shadow {

    position: absolute;
    background-color: #15f4ed;
    opacity: 0.75;
    top: 75%;
    left: -10%;
    min-width: 120%;
    min-height: 40px;

    /* transform: perspective(1em) rotateX(40deg) scale(1, 0.35); */
    filter: blur(2em);

    animation-name: bounce-shadow;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    /* animation-timing-function: ease-in-out; */
}

@keyframes bounce {
    0% { transform: translateY(0) }
    10% { transform: translateY(2px) }
    20% { transform: translateY(4px) }
    30% { transform: translateY(8px) }
    40% { transform: translateY(16px) }
    50% { transform: translateY(32px) }
    60% { transform: translateY(16px) }
    70% { transform: translateY(8px) }
    80% { transform: translateY(4px) }
    90% { transform: translateY(2px) }
    100% { transform: translateY(0) }
}

@keyframes bounce-shadow {
    0% { transform: scale(1,1); opacity: 0.75;}
    10% { transform: scale(0.99,0.99); opacity: 0.8 }
    20% { transform: scale(0.98,0.98); opacity: 0.85 }
    30% { transform: scale(0.96,0.96); opacity: 0.9 }
    40% { transform: scale(0.92,0.92); opacity: 0.95 }
    50% { transform: scale(0.84, 0.84); opacity: 1 }
    60% { transform: scale(0.92,0.92); opacity: 0.95 }
    70% { transform: scale(0.96,0.96); opacity: 0.9 }
    80% { transform: scale(0.98,0.98); opacity: 0.85 }
    90% { transform: scale(0.99,0.99); opacity: 0.8 }
    100% { transform: scale(1,1); opacity: 0.75 }
}

.potd-container .pokemon-card .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    border: none;
}

.potd-container .pokemon-card .card-header .left {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.potd-container .pokemon-card .card-header .left .type {
    font-size: 10px;
    /* background-color: white; */
    padding: 2px 4px;
    border-radius: 6px;
    margin: 0 8px 0 0 ;
    /* box-shadow: 0 0 2px 3px rgba(200,200,200, 0.5) inset, 0 0 2px 2px rgba(50,50,50,0.5); */
}

.potd-container .pokemon-card .card-header .left .name {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 0;
}

.potd-container .pokemon-card .card-header .left .name .poke-num {
    font-size: 10px;
}

.potd-container .pokemon-card .card-header .hp {
    font-weight: 700;
    font-size: 10px;
}

.potd-container .pokemon-card .card-header .hp span {
    font-size: 16px
}

.potd-container .pokemon-card .image-container {
    width: 90%;
    position: relative;
    margin: 0;
    border: 3px solid rgb(223, 223, 223);
    border-radius: 2px;
    box-shadow: 0 0 2px 2px gray inset, 0 0 2px 2px gray;
    margin-left: 5%;
}

.potd-container .pokemon-card .image-container .main-pic {
    height: 224px;
    width: 100%;
}

.potd-container .pokemon-card .image-container .gif-pic {
    position: absolute;
    bottom: 32px;
    right: 0;
}

.potd-container .pokemon-card .image-container .stats {
    font-size: 10px;
    border-top: 3px solid rgb(223, 223, 223);
    box-shadow: 0px 2px 2px 0px gray inset;
    padding-top: 4px;
    text-align: center;
}

.potd-container .pokemon-card .moves-container {
    width: 90%;
    margin-left: 5%;
    padding-top: 12px;
}

.potd-container .pokemon-card .moves-container h2 {
    font-size: 16px;
}

.potd-container .pokemon-card .moves-container .set-info {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 12px;
}

.potd-container .pokemon-card .moves-container .set-info h3 {
    font-size: 6px;
}
.potd-container .pokemon-card .moves-container .set-info h3 span {
    font-size: 10px;
}

.potd-container .pokemon-card .moves-container .move {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
}

.potd-container .pokemon-card .moves-container .move .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.potd-container .pokemon-card .moves-container .move .top h3 {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
}

.type {
    font-size: 9px;
    font-weight: 400;
    text-align: center;
    padding: 1px 6px 4px 6px;
    border-radius: 6px;
    width: 45px;
    margin-bottom: 4px;
}

.potd-container .pokemon-card .moves-container .move .description {
    font-size: 9px;
}

.type.normal {
    background-color: white;
    box-shadow: 0 0 2px 3px rgba(200,200,200, 0.6) inset, 0 0 2px 2px rgba(50,50,50,0.4);
}

.type.psychic {
    background-color: rgb(248,86,134);
    color: white;
    box-shadow: 0 0 2px 2px rgb(214,9,69) inset, 0 0 2px 2px rgba(50,50,50,0.4);
}

.type.fighting {
    background-color: rgb(189,47,39);
    color: white;
    box-shadow: 0 0 2px 2px rgb(130,33,27) inset, 0 0 2px 2px rgba(50,50,50,0.4);
}

.type.dark {
    background-color: rgb(108,85,70);
    color: white;
    box-shadow: 0 0 2px 2px rgb(54,42,35) inset, 0 0 2px 2px rgba(50,50,50,0.4);
}

.type.water {
    background-color: rgb(57, 156, 255);
    color: black;
    box-shadow: 0 0 2px 2px rgb(66, 82, 148) inset, 0 0 2px 2px rgba(50,50,50,0.4);
}

.type.ground {
    background-color: #d6b55a;
    color: black;
    box-shadow: 0 0 2px 2px #735218 inset, 0 0 2px 2px rgba(50,50,50,0.4);
}

.type.fire {
    background-color: #F75231;
    color: white;
    box-shadow: 0 0 2px 2px #732108 inset, 0 0 2px 2px rgba(50,50,50,0.4);
}

.type.bug {
    background-color: #adbd21;
    color: black;
    box-shadow: 0 0 2px 2px #426b39 inset, 0 0 2px 2px rgba(50,50,50,0.4);
}

.type.grass {
    background-color: #7bec52;
    color: black;
    box-shadow: 0 0 2px 2px #426b39 inset, 0 0 2px 2px rgba(50,50,50,0.4);
}

.type.poison {
    background-color: #B55AA5;
    color: black;
    box-shadow: 0 0 2px 2px #4A3952 inset, 0 0 2px 2px rgba(50,50,50,0.4);
}

.type.flying {
    background-color: #9CADF7;
    color: black;
    box-shadow: 0 0 2px 2px #425294 inset, 0 0 2px 2px rgba(50,50,50,0.4);
}

.potd-container .pokemon-card .moves-container .ev-iv {
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.potd-container .pokemon-card .moves-container .ev-iv h3 {
    font-size: 6px;
}

.potd-container .pokemon-card .moves-container .ev-iv h3 span {
    font-size: 10px;
}

.season-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 60%;
    margin-right: 20px;
}

.season-header .bracket-container {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 10px;
    border: #FF10F0 0.125em solid;
    box-shadow: inset 0 0 0.5em 0 #FF10F0, 0 0 0.5em 0 #FF10F0;
}

.season-header h5 {
    font-size: 1.3rem;
    font-weight: 400;
    color: #FF10F0;
    text-shadow: 0 0 0.125em hsl(0 0% 100% / 0.3), 0 0 0.45em currentColor;
}

.season-header h1 {
    font-size: 3rem;
    margin: 40px auto 100px auto;
  
    display: inline-block;
    cursor: pointer;
    text-decoration: none;
    color: #FF10F0;
    border: #FF10F0 0.125em solid;
    padding: 0.25em 1em;
    border-radius: 0.25em;
  
    text-shadow: 0 0 0.125em hsl(0 0% 100% / 0.3), 0 0 0.45em currentColor;
  
    box-shadow: inset 0 0 0.5em 0 #FF10F0, 0 0 0.5em 0 #FF10F0;
  
    position: relative;
  }
  
  .season-header h1::before {
    pointer-events: none;
    content: "";
    position: absolute;
    background: #FF10F0;
    top: 120%;
    left: 0;
    width: 100%;
    height: 100%;
  
    transform: perspective(1em) rotateX(40deg) scale(1, 0.35);
    filter: blur(1em);
    opacity: 0.7;
  }
  
  .season-header h1::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0 0 2em 0.5em #FF10F0;
    opacity: 0;
    background-color: #FF10F0;
    z-index: -1;
    transition: opacity 100ms linear;
  }
  
  .season-header h1:hover,
  .season-header h1:focus {
    color: #001a45;
    background-color: #FF10F0;
    text-shadow: none;
    box-shadow: 0 0 2em 0.5em #FF10F0;;
  }
  
  .season-header h1:hover::before,
  .season-header h1:focus::before {
    opacity: 1;
  }
  .season-header h1:hover::after,
  .season-header h1:focus::after {
    opacity: 1;
  }
  
  @media only screen and (max-width: 1000px) { 
    .home .container {
        display: flex;
        height: auto;
        flex-direction: column-reverse;

    }

    .potd-header {
        margin-right: 12px;
        writing-mode: sideways-lr;
    }

    .potd-container {
        height: auto;
        margin-bottom: 200px;
    }

    .season-header {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 40px auto 80px auto;
        width: 90%;
    }

    .potd-container .shadow {
        top: 120%;
    }

    .season-header h1 {
        font-size: 2rem;
        margin-bottom: 120px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/component_css/MainPage.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,uBAAuB;AAC3B;AACA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,iEAAiE;IACjE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mCAAmC;IACnC,mBAAmB;IACnB,iCAAiC;IACjC,mHAAmH;IACnH,qCAAqC;IACrC,gCAAgC;IAChC,sBAAsB;IACtB,sBAAsB;IACtB,mCAAmC;IACnC,+BAA+B;AACnC;;AAEA;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,QAAQ;IACR,UAAU;IACV,eAAe;IACf,gBAAgB;;IAEhB,+DAA+D;IAC/D,iBAAiB;;IAEjB,6BAA6B;IAC7B,sBAAsB;IACtB,mCAAmC;IACnC,4CAA4C;AAChD;;AAEA;IACI,KAAK,yBAAyB;IAC9B,MAAM,2BAA2B;IACjC,MAAM,2BAA2B;IACjC,MAAM,2BAA2B;IACjC,MAAM,4BAA4B;IAClC,MAAM,4BAA4B;IAClC,MAAM,4BAA4B;IAClC,MAAM,2BAA2B;IACjC,MAAM,2BAA2B;IACjC,MAAM,2BAA2B;IACjC,OAAO,yBAAyB;AACpC;;AAEA;IACI,KAAK,qBAAqB,EAAE,aAAa,CAAC;IAC1C,MAAM,2BAA2B,EAAE,aAAa;IAChD,MAAM,2BAA2B,EAAE,cAAc;IACjD,MAAM,2BAA2B,EAAE,aAAa;IAChD,MAAM,2BAA2B,EAAE,cAAc;IACjD,MAAM,4BAA4B,EAAE,WAAW;IAC/C,MAAM,2BAA2B,EAAE,cAAc;IACjD,MAAM,2BAA2B,EAAE,aAAa;IAChD,MAAM,2BAA2B,EAAE,cAAc;IACjD,MAAM,2BAA2B,EAAE,aAAa;IAChD,OAAO,qBAAqB,EAAE,cAAc;AAChD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,0FAA0F;AAC9F;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,oCAAoC;IACpC,kBAAkB;IAClB,oDAAoD;IACpD,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,wCAAwC;IACxC,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,oFAAoF;AACxF;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,2EAA2E;AAC/E;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,4EAA4E;AAChF;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,2EAA2E;AAC/E;;AAEA;IACI,mCAAmC;IACnC,YAAY;IACZ,8EAA8E;AAClF;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qEAAqE;AACzE;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qEAAqE;AACzE;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qEAAqE;AACzE;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qEAAqE;AACzE;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qEAAqE;AACzE;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qEAAqE;AACzE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,0DAA0D;AAC9D;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sEAAsE;AAC1E;;AAEA;IACI,eAAe;IACf,4BAA4B;;IAE5B,qBAAqB;IACrB,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,6BAA6B;IAC7B,mBAAmB;IACnB,qBAAqB;;IAErB,sEAAsE;;IAEtE,0DAA0D;;IAE1D,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;;IAEZ,yDAAyD;IACzD,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iCAAiC;IACjC,UAAU;IACV,yBAAyB;IACzB,WAAW;IACX,gCAAgC;EAClC;;EAEA;;IAEE,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,iCAAiC;EACnC;;EAEA;;IAEE,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;;EAEA;IACE;QACI,aAAa;QACb,YAAY;QACZ,8BAA8B;;IAElC;;IAEA;QACI,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,2BAA2B;QAC3B,UAAU;IACd;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;EACF","sourcesContent":["html, body {\n    height: 100%;\n}\n\n.home {\n    background-color: #001a45;\n    margin-top: -50px;\n    padding-top: 50px;\n    min-height: 100%;\n}\n\n.home .container {\n    display: flex;\n    height: auto;\n    width: 100%;\n    max-width: 1920px;\n    padding: 0;\n    margin: 0 auto;\n    justify-content: center;\n}\n.potd {\n    display: flex;\n}\n\n.potd-container {\n    margin-top: 40px;\n    border-right: 2px ;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n    height: 800px;\n}\n\n.potd-header {\n    color: #15F4EE;\n    text-shadow: 0 0 0.125em hsl(0 0% 100% / 0.5), 0 0 0.45em #15F4EE;\n    margin-top: 30px;\n    margin-right: 60px;\n    font-size: 24px;\n    writing-mode: vertical-lr;\n    text-orientation: upright;\n}\n\n.potd-container .pokemon-card {\n    position: relative;\n    min-width: 300px;\n    max-width: 60%;\n    border: 10px solid rgb(253,226,101);\n    border-radius: 20px;\n    background: rgb(210,213,205, 0.8);\n    background: linear-gradient(90deg, rgba(210,213,205,0.8) 0%, rgba(255,255,255,0.8) 50%, rgba(218,221,214,0.8) 100%);\n    box-shadow: 0 0 1px 1px #A89A75 inset;\n    box-shadow: 0 0 10px 3px #15F4EE;\n    animation-name: bounce;\n    animation-duration: 2s;\n    animation-iteration-count: infinite;\n    animation-timing-function: ease;\n}\n\n.potd-container .shadow {\n\n    position: absolute;\n    background-color: #15f4ed;\n    opacity: 0.75;\n    top: 75%;\n    left: -10%;\n    min-width: 120%;\n    min-height: 40px;\n\n    /* transform: perspective(1em) rotateX(40deg) scale(1, 0.35); */\n    filter: blur(2em);\n\n    animation-name: bounce-shadow;\n    animation-duration: 2s;\n    animation-iteration-count: infinite;\n    /* animation-timing-function: ease-in-out; */\n}\n\n@keyframes bounce {\n    0% { transform: translateY(0) }\n    10% { transform: translateY(2px) }\n    20% { transform: translateY(4px) }\n    30% { transform: translateY(8px) }\n    40% { transform: translateY(16px) }\n    50% { transform: translateY(32px) }\n    60% { transform: translateY(16px) }\n    70% { transform: translateY(8px) }\n    80% { transform: translateY(4px) }\n    90% { transform: translateY(2px) }\n    100% { transform: translateY(0) }\n}\n\n@keyframes bounce-shadow {\n    0% { transform: scale(1,1); opacity: 0.75;}\n    10% { transform: scale(0.99,0.99); opacity: 0.8 }\n    20% { transform: scale(0.98,0.98); opacity: 0.85 }\n    30% { transform: scale(0.96,0.96); opacity: 0.9 }\n    40% { transform: scale(0.92,0.92); opacity: 0.95 }\n    50% { transform: scale(0.84, 0.84); opacity: 1 }\n    60% { transform: scale(0.92,0.92); opacity: 0.95 }\n    70% { transform: scale(0.96,0.96); opacity: 0.9 }\n    80% { transform: scale(0.98,0.98); opacity: 0.85 }\n    90% { transform: scale(0.99,0.99); opacity: 0.8 }\n    100% { transform: scale(1,1); opacity: 0.75 }\n}\n\n.potd-container .pokemon-card .card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 40px;\n    border: none;\n}\n\n.potd-container .pokemon-card .card-header .left {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.potd-container .pokemon-card .card-header .left .type {\n    font-size: 10px;\n    /* background-color: white; */\n    padding: 2px 4px;\n    border-radius: 6px;\n    margin: 0 8px 0 0 ;\n    /* box-shadow: 0 0 2px 3px rgba(200,200,200, 0.5) inset, 0 0 2px 2px rgba(50,50,50,0.5); */\n}\n\n.potd-container .pokemon-card .card-header .left .name {\n    font-size: 18px;\n    font-weight: 700;\n    margin-bottom: 0;\n}\n\n.potd-container .pokemon-card .card-header .left .name .poke-num {\n    font-size: 10px;\n}\n\n.potd-container .pokemon-card .card-header .hp {\n    font-weight: 700;\n    font-size: 10px;\n}\n\n.potd-container .pokemon-card .card-header .hp span {\n    font-size: 16px\n}\n\n.potd-container .pokemon-card .image-container {\n    width: 90%;\n    position: relative;\n    margin: 0;\n    border: 3px solid rgb(223, 223, 223);\n    border-radius: 2px;\n    box-shadow: 0 0 2px 2px gray inset, 0 0 2px 2px gray;\n    margin-left: 5%;\n}\n\n.potd-container .pokemon-card .image-container .main-pic {\n    height: 224px;\n    width: 100%;\n}\n\n.potd-container .pokemon-card .image-container .gif-pic {\n    position: absolute;\n    bottom: 32px;\n    right: 0;\n}\n\n.potd-container .pokemon-card .image-container .stats {\n    font-size: 10px;\n    border-top: 3px solid rgb(223, 223, 223);\n    box-shadow: 0px 2px 2px 0px gray inset;\n    padding-top: 4px;\n    text-align: center;\n}\n\n.potd-container .pokemon-card .moves-container {\n    width: 90%;\n    margin-left: 5%;\n    padding-top: 12px;\n}\n\n.potd-container .pokemon-card .moves-container h2 {\n    font-size: 16px;\n}\n\n.potd-container .pokemon-card .moves-container .set-info {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.potd-container .pokemon-card .moves-container .set-info h3 {\n    font-size: 6px;\n}\n.potd-container .pokemon-card .moves-container .set-info h3 span {\n    font-size: 10px;\n}\n\n.potd-container .pokemon-card .moves-container .move {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 16px;\n}\n\n.potd-container .pokemon-card .moves-container .move .top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.potd-container .pokemon-card .moves-container .move .top h3 {\n    font-size: 14px;\n    font-weight: 600;\n    margin-bottom: 4px;\n}\n\n.type {\n    font-size: 9px;\n    font-weight: 400;\n    text-align: center;\n    padding: 1px 6px 4px 6px;\n    border-radius: 6px;\n    width: 45px;\n    margin-bottom: 4px;\n}\n\n.potd-container .pokemon-card .moves-container .move .description {\n    font-size: 9px;\n}\n\n.type.normal {\n    background-color: white;\n    box-shadow: 0 0 2px 3px rgba(200,200,200, 0.6) inset, 0 0 2px 2px rgba(50,50,50,0.4);\n}\n\n.type.psychic {\n    background-color: rgb(248,86,134);\n    color: white;\n    box-shadow: 0 0 2px 2px rgb(214,9,69) inset, 0 0 2px 2px rgba(50,50,50,0.4);\n}\n\n.type.fighting {\n    background-color: rgb(189,47,39);\n    color: white;\n    box-shadow: 0 0 2px 2px rgb(130,33,27) inset, 0 0 2px 2px rgba(50,50,50,0.4);\n}\n\n.type.dark {\n    background-color: rgb(108,85,70);\n    color: white;\n    box-shadow: 0 0 2px 2px rgb(54,42,35) inset, 0 0 2px 2px rgba(50,50,50,0.4);\n}\n\n.type.water {\n    background-color: rgb(57, 156, 255);\n    color: black;\n    box-shadow: 0 0 2px 2px rgb(66, 82, 148) inset, 0 0 2px 2px rgba(50,50,50,0.4);\n}\n\n.type.ground {\n    background-color: #d6b55a;\n    color: black;\n    box-shadow: 0 0 2px 2px #735218 inset, 0 0 2px 2px rgba(50,50,50,0.4);\n}\n\n.type.fire {\n    background-color: #F75231;\n    color: white;\n    box-shadow: 0 0 2px 2px #732108 inset, 0 0 2px 2px rgba(50,50,50,0.4);\n}\n\n.type.bug {\n    background-color: #adbd21;\n    color: black;\n    box-shadow: 0 0 2px 2px #426b39 inset, 0 0 2px 2px rgba(50,50,50,0.4);\n}\n\n.type.grass {\n    background-color: #7bec52;\n    color: black;\n    box-shadow: 0 0 2px 2px #426b39 inset, 0 0 2px 2px rgba(50,50,50,0.4);\n}\n\n.type.poison {\n    background-color: #B55AA5;\n    color: black;\n    box-shadow: 0 0 2px 2px #4A3952 inset, 0 0 2px 2px rgba(50,50,50,0.4);\n}\n\n.type.flying {\n    background-color: #9CADF7;\n    color: black;\n    box-shadow: 0 0 2px 2px #425294 inset, 0 0 2px 2px rgba(50,50,50,0.4);\n}\n\n.potd-container .pokemon-card .moves-container .ev-iv {\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n}\n\n.potd-container .pokemon-card .moves-container .ev-iv h3 {\n    font-size: 6px;\n}\n\n.potd-container .pokemon-card .moves-container .ev-iv h3 span {\n    font-size: 10px;\n}\n\n.season-header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 60%;\n    margin-right: 20px;\n}\n\n.season-header .bracket-container {\n    width: 100%;\n    padding: 20px;\n    box-sizing: border-box;\n    border-radius: 10px;\n    border: #FF10F0 0.125em solid;\n    box-shadow: inset 0 0 0.5em 0 #FF10F0, 0 0 0.5em 0 #FF10F0;\n}\n\n.season-header h5 {\n    font-size: 1.3rem;\n    font-weight: 400;\n    color: #FF10F0;\n    text-shadow: 0 0 0.125em hsl(0 0% 100% / 0.3), 0 0 0.45em currentColor;\n}\n\n.season-header h1 {\n    font-size: 3rem;\n    margin: 40px auto 100px auto;\n  \n    display: inline-block;\n    cursor: pointer;\n    text-decoration: none;\n    color: #FF10F0;\n    border: #FF10F0 0.125em solid;\n    padding: 0.25em 1em;\n    border-radius: 0.25em;\n  \n    text-shadow: 0 0 0.125em hsl(0 0% 100% / 0.3), 0 0 0.45em currentColor;\n  \n    box-shadow: inset 0 0 0.5em 0 #FF10F0, 0 0 0.5em 0 #FF10F0;\n  \n    position: relative;\n  }\n  \n  .season-header h1::before {\n    pointer-events: none;\n    content: \"\";\n    position: absolute;\n    background: #FF10F0;\n    top: 120%;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  \n    transform: perspective(1em) rotateX(40deg) scale(1, 0.35);\n    filter: blur(1em);\n    opacity: 0.7;\n  }\n  \n  .season-header h1::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    box-shadow: 0 0 2em 0.5em #FF10F0;\n    opacity: 0;\n    background-color: #FF10F0;\n    z-index: -1;\n    transition: opacity 100ms linear;\n  }\n  \n  .season-header h1:hover,\n  .season-header h1:focus {\n    color: #001a45;\n    background-color: #FF10F0;\n    text-shadow: none;\n    box-shadow: 0 0 2em 0.5em #FF10F0;;\n  }\n  \n  .season-header h1:hover::before,\n  .season-header h1:focus::before {\n    opacity: 1;\n  }\n  .season-header h1:hover::after,\n  .season-header h1:focus::after {\n    opacity: 1;\n  }\n  \n  @media only screen and (max-width: 1000px) { \n    .home .container {\n        display: flex;\n        height: auto;\n        flex-direction: column-reverse;\n\n    }\n\n    .potd-header {\n        margin-right: 12px;\n        writing-mode: sideways-lr;\n    }\n\n    .potd-container {\n        height: auto;\n        margin-bottom: 200px;\n    }\n\n    .season-header {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin: 40px auto 80px auto;\n        width: 90%;\n    }\n\n    .potd-container .shadow {\n        top: 120%;\n    }\n\n    .season-header h1 {\n        font-size: 2rem;\n        margin-bottom: 120px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
